module.exports = __webpack_public_path__ + "img/Unidad18-6.03d86d50.png";